module.exports = __webpack_public_path__ + "static/media/came.204a6d21.png";